import {connect} from "react-redux";
import LeadNewActivity from './newActivity'
import {bindActionCreators} from "redux";
import {newActivity} from "../../../../service/Activity/action";
import {getActivity} from "../../../../service/Lead/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    saveNewActivity:state.Activity.saveNewActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    leadActivity:state.Lead.leadActivity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            newActivity,
            getActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadNewActivity);
